import intl from 'react-intl-universal';

export default intl.get.bind(intl);
